import Card from "components/card";
import InsumoMenu from "./InsumoMenu";
import { columns } from "../columns";
import InsumoDrawer from "./InsumoDrawer";
import React, { useState, useEffect } from "react";
import { getAllInsumos } from "../functions";
import { Box, CircularProgress, Typography, Tooltip, TextField, InputAdornment } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch } from "react-redux";
import InsumoDelete from "./InsumoDelete";
import DataGridMarifer from "components/dataGridMarifer/dataGridMarifer";
import ImpresionQRModalInsumos from "./ImpresionQRModalInsumos";
import EtiquetasInsumosModal from "./EtiquetasInsumosModal";
import ReporteInsumosModal from "./ReporteInsumosModal";
import GuiaEtiquetasModal from "./GuiaEtiquetasModal";

const InsumosTable = () => {
  const [refresh, setRefresh] = useState(false);
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openQR, setOpenQR] = useState(false);
  const [openEtiquetas, setOpenEtiquetas] = useState(false);
  const [openReporte, setOpenReporte] = useState(false);
  const [openGuia, setOpenGuia] = useState(false);
  const [mode, setMode] = useState("POST");
  const [insumoData, setInsumoData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [dataColumns, setDataColumns] = useState(null);
  const dispatch = useDispatch();

  const handleOpenQR = () => setOpenQR(true);
  const handleCloseQR = () => setOpenQR(false);

  useEffect(() => {
    const fetchData = async () => {
      let insumos = await getAllInsumos();
      setInsumoData(insumos);
    };
    fetchData();
      let col = columns(
        setOpen,
        setMode,
        setOpenDelete,
        dispatch,
        refresh,
        setRefresh,
        handleOpenQR
      );
      setDataColumns(col);
  }, [open, openDelete, dispatch, refresh]);

  const handleClose = () => {
    setOpen(false);
  };

  const filteredInsumos = insumoData?.filter((item) =>
    item.nombre?.toLowerCase().includes(searchTerm.toLowerCase())
  ) ?? [];
  return (
    <Box sx={{ height: "750px", width: "100%" }}>
      <ImpresionQRModalInsumos open={openQR} onClose={handleCloseQR} />
      <EtiquetasInsumosModal open={openEtiquetas} onClose={() => setOpenEtiquetas(false)} insumos={insumoData || []} />
      <ReporteInsumosModal open={openReporte} onClose={() => setOpenReporte(false)} insumos={insumoData || []} />
      <GuiaEtiquetasModal open={openGuia} onClose={() => setOpenGuia(false)} insumos={insumoData || []} />
      <InsumoDelete openDelete={openDelete} setOpenDelete={setOpenDelete} />
      <InsumoDrawer open={open} handleClose={handleClose} mode={mode} />
      <Card extra={"w-full h-full p-4"}>
        {/* <div className="relative flex items-center justify-end">
              <div className="text-xl font-bold text-navy-700 dark:text-white">
                <InsumoMenu setOpen={setOpen} setMode={setMode} />
              </div>
            </div> */}
        <div className="relative flex items-center justify-end gap-2">
          <TextField
            size="small"
            placeholder="Buscar por nombre..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "#f43f5e", fontSize: 18 }} />
                </InputAdornment>
              ),
            }}
            sx={{
              width: 240,
              "& .MuiOutlinedInput-root": {
                fontFamily: "'Poppins', sans-serif",
                fontSize: "0.85rem",
                borderRadius: 2,
                "&.Mui-focused fieldset": { borderColor: "#f43f5e" },
              },
              "& .MuiInputLabel-root.Mui-focused": { color: "#f43f5e" },
            }}
          />
          <Tooltip title="Reporte PDF — Catálogo de habilitados" placement="top">
            <button
              onClick={() => setOpenReporte(true)}
              style={{
                display: "flex", alignItems: "center", gap: 4,
                background: "linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)",
                border: "none", borderRadius: 8, padding: "7px 14px",
                color: "#fff", cursor: "pointer",
                fontFamily: "'Poppins', sans-serif", fontWeight: 600, fontSize: "0.8rem",
                boxShadow: "0 3px 10px rgba(124,58,237,0.35)",
              }}
            >
              <PictureAsPdfIcon style={{ fontSize: 18 }} />
              Reporte
            </button>
          </Tooltip>
          <Tooltip title="Imprimir etiquetas de código de barras de todos los habilitados" placement="top">
            <button
              onClick={() => setOpenEtiquetas(true)}
              style={{
                display: "flex", alignItems: "center", gap: 4,
                background: "linear-gradient(135deg, #0ea5e9 0%, #6366f1 100%)",
                border: "none", borderRadius: 8, padding: "7px 14px",
                color: "#fff", cursor: "pointer",
                fontFamily: "'Poppins', sans-serif", fontWeight: 600, fontSize: "0.8rem",
                boxShadow: "0 3px 10px rgba(14,165,233,0.35)",
              }}
            >
              <QrCode2Icon style={{ fontSize: 18 }} />
              Etiquetas
            </button>
          </Tooltip>
          <Tooltip title="Guía: qué etiqueta va con qué producto y dónde pegarla" placement="top">
            <button
              onClick={() => setOpenGuia(true)}
              style={{
                display: "flex", alignItems: "center", gap: 4,
                background: "linear-gradient(135deg, #059669 0%, #10b981 100%)",
                border: "none", borderRadius: 8, padding: "7px 14px",
                color: "#fff", cursor: "pointer",
                fontFamily: "'Poppins', sans-serif", fontWeight: 600, fontSize: "0.8rem",
                boxShadow: "0 3px 10px rgba(5,150,105,0.35)",
              }}
            >
              <MenuBookIcon style={{ fontSize: 18 }} />
              Guía de etiquetas
            </button>
          </Tooltip>
          <Tooltip title="Agregar Nuevo Insumo" placement="top">
            <button
              onClick={() => { setOpen(true); setMode("POST"); }}
              className="flex min-w-[80px] items-center
                                     justify-center rounded-md bg-pink-500
                                     px-3 py-2 text-white shadow-md transition hover:bg-pink-600
                                     active:bg-pink-700"
            >
              <AddCircleIcon className="text-white" />
            </button>
          </Tooltip>
        </div>
        {insumoData ? (
          <DataGridMarifer
            rows={filteredInsumos}
            columns={dataColumns || []}
          />
        ) : (
          <div className="flex justify-center pt-56">
            <CircularProgress color="primary" />
            <Typography>Cargando datos...</Typography>
          </div>
        )}
      </Card>
    </Box>
  );
};
export default InsumosTable;
